import React from 'react';
import './hovercard.css';

const Hovercard = () => {
  return (
    <div className='hovercard-container'>
      <div className="tooltip">
        Hover to see more!</div>
    <div className="cards-container">
      <div className="card" id="ai">
        <p className="phrase">AI: Turning your 'What if?' into 'Why not?</p>
      </div>
      <div className="card" id="xr">
        <p className="phrase">Step into XR—where reality gets a remix and imagination takes the wheel.</p>
      </div>
      <div className="card" id="robots">
        <p className="phrase">Robots - Because humans needed extra hands and cooler dance moves</p>
      </div>
      <div className="card" id="sustainability">
        <p className="phrase">Sustainability: Because Earth doesn’t come with a backup plan.</p>
      </div>
    </div>
    </div>
  );
};

export default Hovercard;
